import { GENERATE_URL } from "@services/helpers/request";

const PREFIX_URL = "/ParasutAccount";

export const GetAll = (options) => GENERATE_URL(`${PREFIX_URL}`, options);

export default {
  GetAll,
};
